import { useQuery } from '@tanstack/react-query';
import api from './axios';

/**
 * Nav/module visibility configured by the tenant admin. Mirrors the query used by the sidebar so a
 * module hidden from navigation (e.g. cheques, contacts) can also be hidden from related UI.
 */
export function useModuleVisibility() {
  const query = useQuery<{ hidden: string[] }>({
    queryKey: ['nav-visibility'],
    queryFn: () => api.get('/settings/navigation').then((r) => r.data),
    staleTime: 5 * 60_000,
  });
  const hidden = query.data?.hidden ?? [];
  return { isHidden: (key: string) => hidden.includes(key) };
}
